import * as React from "react";
import {
  Form,
  Select,
  DatePicker,
  Input,
  Checkbox,
  InputNumber,
  Divider
} from "antd";
import {
  DateFormats,
  ReportingPeriodForm as FormContants,
  ReportingPeriodStatusConstants,
  InputNumberConstants
} from "../../../common/Constants";
import moment from "moment";
import { TReportingPeriodPresentationModel } from "../../../presenter/reporting/model/ReportingPeriodPresentationModel";
import { IReportingType } from "../../../model/reporting/ReportingType";
import Text from "antd/lib/typography/Text";
import SelectInput from "../../components/app/SelectInput";

const ReportingPeriodForm = ({
  getFieldDecorator,
  translate,
  rowData,
  codebooks
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: TReportingPeriodPresentationModel;
  codebooks: IReportingType[];
}) => {
  return (
    <Form>
      <Form.Item label={translate("reporting_periods.reporting_type_code")}>
        {getFieldDecorator(FormContants.Fields.REPORTING_TYPE_CODE, {
          initialValue: rowData && rowData.reportingTypeCode,
          rules: [
            {
              required: true,
              message: translate("reporting_periods.required_messages", {
                field: translate("reporting_periods.reporting_type_code")
              })
            }
          ]
        })(
          <SelectInput
            placeholder={translate(
              "reporting_periods.select_reporting_type_code"
            )}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"code"}
            selectOptionValue={"name"}
            selectOptions={codebooks}
            disabled={rowData ? true : false}
          />
        )}
      </Form.Item>
      <Form.Item label={translate("reporting_periods.name")}>
        {getFieldDecorator(FormContants.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("reporting_periods.required_messages", {
                field: translate("reporting_periods.name")
              })
            }
          ]
        })(<Input disabled={rowData ? true : false} />)}
      </Form.Item>
      <div className="ant-form-row-two-items">
        <Form.Item
          label={translate("reporting_periods.number_of_reporting_period")}
          className="ant-form-item-width"
        >
          {getFieldDecorator(FormContants.Fields.NUMBER_OF_REPORTING_PERIOD, {
            initialValue: rowData && rowData.numberOfReportingPeriod,
            rules: [
              {
                required: true,
                message: translate("reporting_periods.required_messages", {
                  field: translate(
                    "reporting_periods.number_of_reporting_period"
                  )
                })
              }
            ]
          })(
            <InputNumber
              min={InputNumberConstants.MIN_VALUE}
              disabled={rowData ? true : false}
            />
          )}
        </Form.Item>
        <Form.Item
          label={translate("reporting_periods.status")}
          className="ant-form-item-width"
        >
          {getFieldDecorator(FormContants.Fields.STATUS, {
            initialValue: rowData && rowData.status,
            rules: [
              {
                required: true,
                message: translate("reporting_periods.required_messages", {
                  field: translate("reporting_periods.status")
                })
              }
            ]
          })(
            <Select
              placeholder={translate("reporting_periods.select_status")}
              style={{ width: 200 }}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
            >
              <Select.Option key={ReportingPeriodStatusConstants.ACTIVE}>
                {FormContants.Status.ACTIVE}
              </Select.Option>
              <Select.Option key={ReportingPeriodStatusConstants.INACTIVE}>
                {FormContants.Status.INACTIVE}
              </Select.Option>
            </Select>
          )}
        </Form.Item>
      </div>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("reporting_periods.reporting_period")}
        </Text>

        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("reporting_periods.period_from")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.PERIOD_FROM, {
              initialValue:
                rowData && rowData.periodFrom
                  ? moment(rowData.periodFrom, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("reporting_periods.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={rowData ? true : false}
              />
            )}
          </Form.Item>
          <Form.Item
            label={translate("reporting_periods.period_to")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.PERIOD_TO, {
              initialValue:
                rowData && rowData.periodTo
                  ? moment(rowData.periodTo, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("reporting_periods.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={rowData ? true : false}
              />
            )}
          </Form.Item>
        </div>

        <Divider></Divider>
      </div>
      <Form.Item label={translate("reporting_periods.valid")}>
        {getFieldDecorator(FormContants.Fields.VALID, {
          valuePropName: "checked",
          initialValue: rowData ? rowData.valid : true,
          rules: [
            {
              required: true,
              message: translate("reporting_periods.required_messages", {
                field: translate("reporting_periods.valid")
              })
            }
          ]
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default ReportingPeriodForm;
